module.exports = __webpack_public_path__ + "static/media/roof-header@2x.99539365.jpg";